module.exports = __webpack_public_path__ + "img/comment.8a4eff30.svg";